module.exports = __webpack_public_path__ + "static/9-13cac25ad4e4ef8350b8da91d05a3e0f.jpeg";